(function () {
    'use strict';

    angular.module('PWAPoCApp').factory('botekService', botekService);

    botekService.$inject = ['$q', '$rootScope', 'locationService', 'routeStopsService',
        'pollingService', 'commonUtil', 'cacheService', 'rfidErrorModalService', 'toasterService',
        'translateService'];

    function botekService($q, $rootScope, locationService, routeStopsService,
        pollingService, commonUtil, cacheService, rfidErrorModalService, toasterService,
        translateService) {

        
        const botekService = {
            getFiles: getFiles,
            getWeightValues: getWeightValues,
            deleteAllFilesFromServer: deleteAllFilesFromServer,
            startPolling: startPolling,
            startPollingByRFID: startPollingByRFID,
            stopPollingByRFID: stopPollingByRFID,
            stopPolling: stopPolling,
            clearCachedFiles: clearCachedFiles
        };

        let polling = null;
        let pollingByRFID = null;
        let lastRouteLineIds = [];
        let isFilesDeleting = false;

        let isRfidErrorModalOpen = false;

        const mergedFilesCacheKey = '_mergedRFIDFiles_'; 
        const allFilesCacheKey = '_allRFIDFiles_';

        $rootScope.isRfidError = false;

        return botekService;

        async function startPollingByRFID(routeStopList, orderId) {
            const routeLineIds = routeStopList.map(({ routeLineId }) => routeLineId);
            if (pollingByRFID && !_.isEqual(lastRouteLineIds, routeLineIds)) {
              stopPollingByRFID();
            }
          
            if (pollingByRFID || (!pollingByRFID && _.isEqual(lastRouteLineIds, routeLineIds))) {
              return;
            }
          
            lastRouteLineIds = routeLineIds;

            await deleteAllFilesFromServer().catch((err) => {
                console.error('deleteAllFilesFromServer failed on start polling, continuing anyway:', err);
                openRfidErrorModal(err);
            });
          
            pollingByRFID = pollingService.startPolling($rootScope.botekSettings?.botekHyperionPollingIntervalMs, async () => {
              try {
                const fetchedFiles = await getFiles();
                
                if (fetchedFiles.length) {
                    await cacheFetchedFiles(fetchedFiles, orderId);
                    await deleteRFIDFiles(fetchedFiles);
                } else return;

                const routeStopsWithFiles = getRouteStopsWithRFIDFiles(routeStopList, fetchedFiles);
                if (!routeStopsWithFiles.length) return;
                await getMergedRouteStopsWithRFIDFiles(routeStopsWithFiles, orderId);
                $rootScope.isRfidError = false;
              } catch (error) {
                console.error('Error in pollingByRFID:', error);
                openRfidErrorModal(error);
              }
            }, true);
          };

        function stopPollingByRFID() {
            if (!pollingByRFID || $rootScope.isBotekModalOpen) return;
            if (pollingByRFID) {
                pollingService.stopPolling(pollingByRFID);
                pollingByRFID = null;
            }
        }

        function getRouteStopsWithRFIDFiles(routeStopList, files) {
            const fileById = {};

            for (const fileObj of files) {
                const meta = Object.values(fileObj)[0];
                const id = meta.id;
                if (id == undefined ||id == null || id === "") {
                    continue;
                }
                if (meta.errortext?.length > 0 || meta.errorcode?.length > 0) {
                    if (meta.errortext.toLowerCase() !== 'no rfid') {
                        toasterService.info(`${translateService.translate('rfidErrorModal.modalHeader')}: ${meta.errorcode} - ${meta.errortext}`, {
                                persist: true
                            })
                    }
                    continue;
                }
                fileById[id] = fileObj;
            }

            const result = [];

            for (const routeStop of routeStopList) {
                if (!routeStop.units) continue;

                for (const unit of routeStop.units) {
                    const file = fileById[unit.labelId];
                    if (file) {                        
                        result.push({
                            routeStop,
                            file: file,
                        });                     
                    }
                }  
            }

            return result;
        }

        async function getMergedRouteStopsWithRFIDFiles(routeStopsWithFiles, orderId) {
            const tasks = routeStopsWithFiles.map(async rs => {
                const originalRouteStop = rs.routeStop;
                const routeStop = angular.copy(rs.routeStop);
                const file = rs.file;

                const weightDataButtonIndex = routeStop.dataButtons?.findIndex(
                    db => db.identity === 'Weight'
                );
                if (weightDataButtonIndex === -1) return null;

                const unitIndex = routeStop.units.findIndex(
                    u => u.labelId === getFileRFID(file)
                );
                if (unitIndex === -1) return null;

                const updatedRFIDUnit = getUpdatedRFIDUnit(routeStop, file);
                routeStop.units[unitIndex] = updatedRFIDUnit;

                const updatedWeightDataButton = getUpdatedWeightDataButton(routeStop, file);
                routeStop.dataButtons[weightDataButtonIndex] = updatedWeightDataButton;

                const weight = Number(
                    commonUtil.correctDataButtonValueFloatFormat(
                        getWeightFromFile(file)
                    ).replace(',', '.')
                );

                routeStop.units[unitIndex].unitWeight = weight.toString();

                await cacheMergedFile(routeStop, file, routeStop.units[unitIndex], orderId);
                await routeStopsService.updateRouteStop(orderId, routeStop);

                angular.copy(routeStop, originalRouteStop);

                return routeStop;
            });

            return Promise.all(tasks.filter(Boolean));
        }

        async function cacheMergedFile(routeStop, file, unit, orderId) {
            const cacheKey = mergedFilesCacheKey + orderId;
            const existing = (await cacheService.get(cacheKey)) || [];
            const mergedFile = { address: routeStop.address,
            unit,
            file };
            const mergedFiles = [...existing, mergedFile];
            await cacheService.set(cacheKey, mergedFiles);
        }

        async function cacheFetchedFiles(files, orderId) {
            const cacheKey = allFilesCacheKey + orderId;
            const existing = (await cacheService.get(cacheKey)) || [];
            const mergedFiles = [...existing, ...files];
            await cacheService.set(cacheKey, mergedFiles);
        }

        async function clearCachedFiles(orderId) {
            const mergedCacheKey = mergedFilesCacheKey + orderId;
            const allFilesCacheKeyFull = allFilesCacheKey + orderId;

            await cacheService.remove(mergedCacheKey);
            await cacheService.remove(allFilesCacheKeyFull);
        }

        function getUpdatedRFIDUnit(routeStop, file) {
            const RFIDUnitIndex = routeStop.units.findIndex(u => u.labelId === getFileRFID(file));
            const RFIDUnit = routeStop.units[RFIDUnitIndex];
            return {
                ...RFIDUnit,
                message: 'Ja'
            };
        }
        
        function getUpdatedWeightDataButton(routeStop, file) {
            const RFIDUnit = routeStop.units.find(u => u.labelId === getFileRFID(file));
            const agreementLineId = RFIDUnit.agreementLines[0];
            const weightDataButtonIndex = routeStop.dataButtons.findIndex(db => db.identity === 'Weight');
            const weightDataButton = routeStop.dataButtons[weightDataButtonIndex];
            const currentWeights = getCurrentWeights(routeStop, weightDataButton);
            const newValuesString = getNewValuesString(routeStop, file, agreementLineId, currentWeights);
            const newSumWeightString = calculateNewSumWeightString(newValuesString, agreementLineId);
            return {
                ...weightDataButton,
                values: newValuesString,
                value: newSumWeightString
            };
        }

        function getCurrentWeights(routeStop, weightDataButton) {
            if (!weightDataButton.values) {
                const initWeights = initCurrentWeightArray(routeStop);
                return initWeights;
            }
            else {
                return weightDataButton.values.split(';');
            }
        }

        function initCurrentWeightArray(routeStop) {
            return _.flatten(routeStop.units.map(unit => {
                const agreementLineIds = _.flatten(unit.agreementLines);
                return agreementLineIds.map(al => {
                    return `${al}:null`;
                });
            }));
        }
        
        function getNewValuesString(routeStop, file, agreementLineId, currentWeights) {
            return routeStop.units.map(unit => {
                const agreementLineIds = _.flatten(unit.agreementLines);
        
                return agreementLineIds.map(al => {
                    if (al == agreementLineId) {
                        const weight = getWeightFromFile(file).replace('.', ',');
                        return `${al}:${weight}`;
                    } else {
                        return `${al}:${currentWeights.find(cw => cw.split(':')[0] == al).split(':')[1]}`;
                    }
                }).join(';');
            }).join(';');
        }
        
        function calculateNewSumWeightString(newValuesString, agreementLineId) {
            const sumWeight = newValuesString
            .split(";")
            .reduce((acc, pair) => {
                const [agrLineId, weightStr] = pair.split(":");
                const weight = agrLineId == agreementLineId ? weightStr === "null" ? 0 : Number(weightStr.replace(',', '.')) : 0;
                return acc + weight;
            }, 0);
            return `${sumWeight}`.replace('.', ',');
        }
        

        function startPolling(){
            if (polling) return;
            
            console.log("Polling started");
            deleteAllFilesFromServer()
                .then(() => {
                    console.log('deleteAllFilesFromServer succeeded');
                })
                .catch(function(err){
                    console.error('deleteAllFilesFromServer failed, continuing anyway:', err);
                })
                .then(() => {
                    polling = pollingService.startPolling(
                        $rootScope.botekSettings.botekHyperionPollingIntervalMs,
                        function(){
                            getFiles()
                            .then(function(files){
                                filterFiles(files)
                                .then(function(filteredFiles){
                                    $rootScope.botekFiles = filteredFiles;
                                    const weightValues = getWeightValues(filteredFiles);
                                    setWeightValuesToRootScope(weightValues);
                                })
                                .catch(function(error){
                                    console.error(error)
                                });
                            })
                            .catch(function(error){
                                console.error(error)
                            });
                        }, 
                        true
                    );
                });
        }

        function stopPolling(){
            if (!polling || $rootScope.isBotekModalOpen) return;
            if (polling) {
                pollingService.stopPolling(polling);
                polling = null;
                console.log("Polling stopped");
            }
        }

        function applyTimeFilter(files, timeFilterMinutes = 0){
            if (!files) return;

            const filteredFiles = files.filter(file => {
                const fileDate = new Date(file[getFileId(file)].date + ' ' + file[getFileId(file)].time);
                const now = new Date();
                const diff = now.getTime() - fileDate.getTime();
                const diffMinutes = Math.floor((diff / 1000) / 60);
                return diffMinutes <= timeFilterMinutes;
            });

            return filteredFiles;
        }

        function applyLocationFilter(files, currentLocation, distanceFilterMeters = 1){
            if (!files || !currentLocation) return;
            if (!files.length) return [];

            const filteredFiles = files.filter(file => {
                const distance = geolib.getDistance({
                    latitude: file[getFileId(file)].gpslat,
                    longitude: file[getFileId(file)].gpslong
                },{
                     latitude: currentLocation.coords.latitude,
                     longitude: currentLocation.coords.longitude
                })
               return distance <= distanceFilterMeters;
            });

            return filteredFiles;
        }

        function getWeightValues(files){
            if (!files) return [];
            const weightValues = files.map(file => {
                const objKeys = Object.keys(file);
                const fileName = objKeys[0];
                const weight = file[fileName].weight;
                return weight;
            });

            return weightValues || [];
        }

        function setWeightValuesToRootScope(weightValues){
            const waitingMsg = "Venter på vektdata";
            if (weightValues.length){
                $rootScope.botekWaitingMsg = null;
                
                const numbers = _.map(weightValues, w=>Number(commonUtil.correctDataButtonValueFloatFormat(w).split(',').join('.'))); //"0,0" -> "0" -> 0
                const sum = _.sum(numbers);
                $rootScope.botekSumWeight = sum.toString();
                $rootScope.botekWeightValues = weightValues;
            } else{
                $rootScope.botekSumWeight = "";
                $rootScope.botekWeightValues = [];
                $rootScope.botekWaitingMsg = waitingMsg;
            }
        }

        function getFileId(file){
            const objKeys = Object.keys(file);
            const fileId = objKeys[0];
            return fileId;
        }

        function getFileRFID(file) {
            const objKeys = Object.keys(file);
            const fileName = objKeys[0];
            const RFID = file[fileName].id;
            return RFID;
        }

        function getWeightFromFile(file) {
            const objKeys = Object.keys(file);
            const fileName = objKeys[0];
            const weight = file[fileName].weight;
            return weight;
        }

        async function getFiles() {
            const botekSettings = $rootScope.botekSettings;
            const baseUrl = botekSettings.botekHyperionUrl;
            //Uncomment for test data
            //const fakeData = [{ "D3EX2471.txt": { "id": "666", "weight": (Math.round(Math.random() * 150) / 100).toString(), "date": "2022-05-05", "time": "13:40:18", "errorcode": "", "errortext": "", "modulename": "B6000L", "modulenr": "1", "gpslat": "63.3581", "gpslong": "10.51121", "devnr": "0 " } }, { "D3EX2472.txt": { "id": "777", "weight": "226,0", "date": "2022-04-29", "time": "08:22:21", "errorcode": "", "errortext": "", "modulename": "B6000L", "modulenr": "1", "gpslat": "63.3581", "gpslong": "10.51121", "devnr": "0 " } }, { "D3EX2473.txt": { "id": "AAAAAA2473", "weight": "205,0", "date": "2022-05-05", "time": "13:50:24", "errorcode": "", "errortext": "", "modulename": "B6000L", "modulenr": "1", "gpslat": "5748.2749", "gpslong": "01327.8104", "devnr": "0 " } }, { "D3EX2474.txt": { "id": "AAAAAA2474", "weight": "320,0", "date": "2022-04-29", "time": "08:22:27", "errorcode": "", "errortext": "", "modulename": "B6000L", "modulenr": "1", "gpslat": "5748.2749", "gpslong": "01327.8104", "devnr": "0 " } }];
            //return fakeData;
            //with fetch there's no need for $q.defer()
            try {
                const response = await fetch(baseUrl + '/collection', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (!response.ok) {
                    const text = await response.text().catch(() => null);
                    const msg = `GET ${baseUrl}/collection failed: ${response.status}${text ? ' - ' + text : ''}`;
                    console.error('[getFiles] ' + msg);
                    openRfidErrorModal(msg);
                    return [];
                }

                const data = await response.json();
                $rootScope.isRfidError = false;
                return data || [];
            } catch (error) {
                console.error('[getFiles] error:', error && error.message ? error.message : error);
                openRfidErrorModal(error.message || error);
                return [];
            }
        }

        async function filterFiles(files, botekSettings = $rootScope.botekSettings) {
            if (!files || files.length === 0) {
                return [];
            }

            let timeFilteredFiles = [];
            let locationFilteredFiles = [];
            let filteredFiles = [];

            if (!botekSettings.enableBotekHyperionByLocationTimeLocationFiltering &&
                !botekSettings.enableBotekHyperionByLocationTimeTimeFiltering) {
                return files;
            }

            if (botekSettings.enableBotekHyperionByLocationTimeTimeFiltering) {
                try {
                    timeFilteredFiles = applyTimeFilter(files, botekSettings.botekHyperionByLocationTimeTimeFilterMinutes) || [];
                } catch (err) {
                    console.error('[filterFiles] applyTimeFilter failed:', err);
                    timeFilteredFiles = [];
                }
            }

            if (!botekSettings.enableBotekHyperionByLocationTimeLocationFiltering &&
                botekSettings.enableBotekHyperionByLocationTimeTimeFiltering) {
                return timeFilteredFiles;
            }

            try {
                const currentLocation = await locationService.getCurrentPosition();
                try {
                    locationFilteredFiles = applyLocationFilter(files, currentLocation, botekSettings.botekHyperionByLocationTimeLocationFilterMeters) || [];
                } catch (err) {
                    console.error('[filterFiles] applyLocationFilter failed:', err);
                    locationFilteredFiles = [];
                }

                if (botekSettings.enableBotekHyperionByLocationTimeLocationFiltering &&
                    botekSettings.enableBotekHyperionByLocationTimeTimeFiltering) {

                    filteredFiles = timeFilteredFiles.filter(a => 
                        locationFilteredFiles.some(b => getFileId(a) === getFileId(b))
                    );
                    return filteredFiles;
                } 
                else {
                    return locationFilteredFiles;
                }
            } catch (locErr) {
                console.error('[filterFiles] locationService.getCurrentPosition failed:', locErr);
                if (timeFilteredFiles && timeFilteredFiles.length) {
                    return timeFilteredFiles;
                }
                return [];
            }
        }

        function promiseWithTimeout(promise, ms) {
            return new Promise((resolve, reject) => {
                const timer = setTimeout(() => {
                    reject(new Error('timeout'));
                }, ms);

                promise
                    .then((res) => {
                        clearTimeout(timer);
                        resolve(res);
                    })
                    .catch((err) => {
                        clearTimeout(timer);
                        reject(err);
                    });
            });
        }

        async function deleteAllFilesFromServer(timeoutMs = 10000) {
            if ($rootScope.isBotekModalOpen || isFilesDeleting) { return }
            try {
                isFilesDeleting = true;
                const fileIds = await getAllFileIdsFromServer();

                if (!Array.isArray(fileIds) || fileIds.length === 0) {
                    isFilesDeleting = false;
                    $rootScope.botekFiles = [];
                    setWeightValuesToRootScope([]);
                    return [];
                }

                const safePromises = fileIds.map((id) =>
                    promiseWithTimeout(deleteFile(id), timeoutMs)
                        .then((value) => ({ id, status: 'fulfilled', value }))
                        .catch((reason) => ({ id, status: 'rejected', reason }))
                );

                const results = await Promise.all(safePromises);

                const succeeded = results.filter(r => r.status === 'fulfilled');
                const failed = results.filter(r => r.status === 'rejected');

                console.log(`[deleteAllFilesFromServer] finished: ${succeeded.length} succeeded, ${failed.length} failed`);

                if (failed.length) {
                    console.error('[deleteAllFilesFromServer] failures:', failed);
                }

                $rootScope.botekFiles = [];
                setWeightValuesToRootScope([]);

                isFilesDeleting = false;
                return results;
            } catch (err) {
                isFilesDeleting = false;
                console.error('[deleteAllFilesFromServer] fatal error:', err);
                throw err;
            }
        }

        async function getAllFileIdsFromServer(){
            const botekSettings = $rootScope.botekSettings;
            const baseUrl = botekSettings.botekHyperionUrl;
            //Uncomment for test data
            // const fakeData = [  "D3EX2471.txt" , "D3EX2472.txt" , "D3EX2473.txt" , "D3EX2474.txt" ];
            // deferred.resolve(fakeData);

            //with $http there's a problem with CORS, so we use fetch

            try {
                const response = await fetch(baseUrl + '/collection/list', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                });

                if (!response.ok) {
                    const text = await response.text().catch(()=>null);
                    const msg = `GET ${baseUrl}/collection/list failed: ${response.status}${text ? ' - ' + text : ''}`;
                    console.error(msg);
                    openRfidErrorModal(msg)
                    throw new Error(msg);
                }

                const data = await response.json();
                $rootScope.isRfidError = false;
                return data;
            } catch (error) {
                console.error('[getAllFileIdsFromServer] error:', error);
                openRfidErrorModal(error.message || error);
                throw error;
            }
        }

        async function deleteFile(id){
            const botekSettings = $rootScope.botekSettings;
            const baseUrl = botekSettings.botekHyperionUrl;

            try {
                const response = await fetch(baseUrl + '/collection/' + encodeURIComponent(id), {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                });

                if (!response.ok) {
                    const text = await response.text().catch(()=>null);
                    const msg = `DELETE ${baseUrl}/collection/${id} failed: ${response.status}${text ? ' - ' + text : ''}`;
                    console.error(msg);
                    throw new Error(msg);
                }

                const data = await response.text();
                return data;
            } catch (error) {
                console.error('[deleteFile] error for id', id, error);
                throw error;
            }
        }

        async function deleteRFIDFiles(files) {
            const fileIds = files.map((file) => {
                return getFileId(file);
            });
            const requests = fileIds.map(fileId => deleteFile(fileId));
            const response = await $q.all(requests);
            console.log("Deleted " + fileIds.length + " files");
            return response;
        }

        function openRfidErrorModal(errorMsg) {
            if (!isRfidErrorModalOpen) {
                isRfidErrorModalOpen = true;
                rfidErrorModalService.openRfidErrorModal(errorMsg);
            }
        }

    }
})();
